import React, { useState } from "react";
import {
    Grid,
    Typography,
} from "@mui/material";
import { useTheme, useMediaQuery } from "@mui/material";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import GuardianInviteModal from "./GuardianInviteModal";
import GuardianImage from "../../../../assets/icon/Add_guardian.svg";
import GuardianImageSuccess from "../../../../assets/icon/Add_guardian_success.svg";

const InviteManual = ({ groupCode, schoolName, handleClose, getData, fromDashboard }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [isSuccess, setIsSuccess] = useState(false);

    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Grid
          container
          direction="column"
          alignItems="center"
          spacing={3}
          sx={{ marginLeft: '-10px' }}
        >
          {/* Image */}
          <Grid item sx={{ paddingLeft: '0px !important' }}>
            <img
              src={isSuccess ? GuardianImageSuccess : GuardianImage}
              alt="Add Guardian"
              style={{
                width: isMobile ? '150px' : '200px',
                height: 'auto',
                marginBottom: '10px',
              }}
            />
          </Grid>

          {/* Title */}
          <Grid item sx={{ paddingLeft: '0px !important' }}>
            <Typography
              variant="h6"
              align="center"
              fontWeight="bold"
              color="#321b6d"
            >
              Add Guardian
            </Typography>
            {!isSuccess && (
              <Typography variant="body2" align="center" color="#321b6d">
                Please complete the *mandatory fields. We will not use this
                information for anything. It is confidential and securely kept
                in your portal.
              </Typography>
            )}
          </Grid>

          <GuardianInviteModal
            groupCode={groupCode}
            schoolName={schoolName}
            isSuccess={isSuccess}
            setIsSuccess={setIsSuccess}
            handleClose={handleClose}
            getData={getData}
            fromDashboard={fromDashboard}
          />
        </Grid>
      </LocalizationProvider>
    );
};

export default InviteManual;